import React from 'react';
import styled from 'styled-components';
import Box from '@clasohlson/co-ui-components/Box';
import Grid from '@clasohlson/co-ui-components/Grid';
import Column from '@clasohlson/co-ui-components/Column';
import { BoxClockIcon, BoxReturnIcon, BoxMoneyIcon } from '../icons';
// import { useTranslation } from 'react-i18next';
import { BorderedBox } from '../layout/BorderedBox';
import { getCountryCodeFromUrl, useTranslation } from '../../utils';

const BoxWrapper = styled(Box)`
  margin-bottom: 52px;
  svg {
    margin: 0 auto 22px auto;
    path {
      fill: #000;
    }
  }
  @media screen and (max-width: 600px) {
    margin-bottom: 32px;
    svg {
      margin: 0 auto 8px auto;
    }
  }
`;

const CustomBorderedBox = styled(BorderedBox)`
  padding: 30px 2rem 23px 2rem;
  align-self: stretch;
  flex-grow: 1;
  @media screen and (max-width: 600px) {
    padding: 1rem;
  }
`;

const BoxTitle = styled.h4`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  margin-top: 0;
  margin-bottom: 8px;
  @media screen and (max-width: 600px) {
    font-size: 14px;
    margin-bottom: 4px;
  }
`;

const BoxDescription = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
  text-align: center;
`;

export const ProcessDescription = () => {
  const { t } = useTranslation();
  const country = getCountryCodeFromUrl();
  return (
    <BoxWrapper>
      <Grid spacing="large" alignItems="stretch" justifyContent="flex-start">
        <Column lg="4" md="4" sm="4" xs="6" justifyContent="center">
          <CustomBorderedBox
            style={{ cursor: 'pointer' }}
            onClick={() =>
              (window.location.href = `https://www.clasohlson.com/${country}/terms-and-conditions#rights-of-regret`)
            }
          >
            <BoxClockIcon fontSize="48" />
            <BoxTitle>{t('processOneTitle')}</BoxTitle>
            <BoxDescription>{t('processOneDescription')}</BoxDescription>
          </CustomBorderedBox>
        </Column>
        <Column lg="4" md="4" sm="4" xs="6" flexGrow="1">
          <CustomBorderedBox
            style={{ cursor: 'pointer' }}
            onClick={() =>
              (window.location.href = `https://www.clasohlson.com/${country}/terms-and-conditions#returnpolicy`)
            }
          >
            <BoxReturnIcon fontSize="48" />
            <BoxTitle>{t('processTwoTitle')}</BoxTitle>
            <BoxDescription>{t('processTwoDescription')}</BoxDescription>
          </CustomBorderedBox>
        </Column>
        <Column lg="4" md="4" sm="4" xs="6">
          <CustomBorderedBox
            style={{ cursor: 'pointer' }}
            onClick={() =>
              (window.location.href = `https://www.clasohlson.com/${country}/terms-and-conditions#refunds`)
            }
          >
            <BoxMoneyIcon fontSize="48" />
            <BoxTitle>{t('processThreeTitle')}</BoxTitle>
            <BoxDescription>{t('processThreeDescription')}</BoxDescription>
          </CustomBorderedBox>
        </Column>
      </Grid>
    </BoxWrapper>
  );
};
